import { createSelector } from 'reselect';

// The goal here is to make it so that the state tree gets recalculated only when something on "reports" gets changed
const selectReportsState = createSelector(
  state => state.reports,
  reportsState => reportsState
);

export const selectReportsUrl = createSelector(selectReportsState, reportsState => reportsState.reportsUrl);

export const selectReportsIsLoading = createSelector(selectReportsState, reportsState => reportsState.isLoading);

export const selectIsExportLoading = createSelector(selectReportsState, reportsState => reportsState.isExportLoading);

export const selectWeightChangeData = createSelector(selectReportsState, reportsState => reportsState.weightChangeData);

export const selectBmiData = createSelector(selectReportsState, reportsState => reportsState.bmiData);

export const selectTargetWeightData = createSelector(selectReportsState, reportsState => reportsState.targetWeightData);

export const selectWbgtData = createSelector(selectReportsState, reportsState => reportsState.wbgtData);
